import { useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider } from "@/features/auth/AuthProvider";
import { PaywallProvider } from "@/features/paywall";
import { NotificationProvider } from "@/features/notifications/NotificationProvider";
import { ThemeNotificationProvider } from "@/features/menu/ThemeNotificationProvider";

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60_000,
            retry: 1,
          },
        },
      }),
  );

  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <PaywallProvider>
            <NotificationProvider>
              <ThemeNotificationProvider>{children}</ThemeNotificationProvider>
              <Toaster position="top-center" richColors />
            </NotificationProvider>
          </PaywallProvider>
        </AuthProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
}
